import { z } from "zod";

const schema = z.object({
  fractionalExperience: z.string(),
});

type Schema = z.infer<typeof schema>;

export {
  schema as candidateFractionalExperienceFormSchema,
  type Schema as CandidateFractionalExperienceFormSchema,
};
